import Decimal from 'decimal.js'

export type OrderItem = {
  PropertyID: number
  PropertyName: string
  Amount: string
  Price: string
  TokenPrice: string
}

export type Order = {
  orderId: number
  transactionRequestId: number
  gatewayId: number
  status: string
  backendStatus: string
  amount: number
  orderItems: OrderItem[]
}

export type HotBuyOrderItem = {
  PropertyID: number
  PropertyName: string
  TokenAmount: string
  TokenPriceTaker: string
  TotalPriceTaker: string
  SellOfferID: number
  TokenPriceMaker: string
  TotalPriceMaker: string
  InitialTokenPrice: string
  TokenPriceFee: string
  TokenPriceFeePercent: string
  TotalPriceFee: string
}

export type HotByOrder = {
  id: number
  clientId: number
  amount: string
  items: HotBuyOrderItem[]
  addedAt: number
  modifiedTs: number
  status: string
  backendStatus: string
  statusMsg: string
  transactionRequestId: number
  expiredAt: string
  createdAt: string
  humanCreatedAt: string
  updatedAt: string
  humanUpdatedAt: string
}

export type DepositEdit = {
  transactionId: string
  transactionType: string
  clientId: string
  isAuto: boolean
  isCard: boolean
  processingProvider: string
  processingMethod: string
  status: string
  initialAmount: string
  initialAmountUsd: string
  initialCurrency: string
  clientAmount: string
  clientCurrency: string
  companyAmount: string
  companyCurrency: string
  clientCommission: string
  exchangeRate: string
  companyCommission: string
  commissionCurrency: string
  innerCommission: string
  createdAt: string
  updatedAt: string
  client: Client
  changeHistory: Manager
  changeHistoryAll: ChangeHistoryEntry[]
  gateway: Gateway
  externalTransaction: ExternalTransaction
  externalPaymentTransaction: ExternalPaymentTransaction
  providerId: string
  psId: string
  clientPurseId: number
  clientPurse: ClientPurse
  destinationType: string
  rejectReason: string
  psComment: string
  managerComment: string
  internalComment: string
  destinationId: number
  order: Order
  hotBuyOrder: HotByOrder | null
  product?: string
  needRecalculate: boolean
  confirmedByManagerAt: string
  confirmedByVendorAt: string
  estimatedCommission: string
}

export type ClientPurse = {
  clientId: string
  id: number
  expiry: string
  isCard: boolean
  mask: string
  type: string
  verified: boolean
  clientName: string
  bankName: string
}

export type Client = {
  clientId: string
  email: string
  fullName: string
  partner: boolean
  verified: boolean
  wallets: Wallet[]
  accounts: Account[]
  exchanger: Exchanger
  isTest: boolean
  isPremium: boolean
  country: string
}

export type Wallet = {
  walletId: number
  balance: string
  currency: string
}

export type Account = {
  accountId: number
  balance: string
  currency: string
  isFixRate: boolean
  accountPlatform: string
  mtLogin: string
}

export type Manager = {
  id: string
  user: User
}

export type User = {
  email: string
  fullName: string
}

export type ChangeHistoryEntry = {
  id: number
  entityType: string
  entityId: number
  actionType: string
  actionDetails: string
  createdAt: string
  user: User
}

export type AmountType = {
  initialAmount: Decimal
  initialCurrency: string
  initialAmountVisited: boolean
  initialCurrencyVisited: boolean
  clientAmount: Decimal
  clientCurrency: string
  clientAmountVisited: boolean
  clientCurrencyVisited: boolean
  companyAmount: Decimal
  companyCurrency: string
  companyAmountVisited: boolean
  companyCurrencyVisited: boolean
}

export type UpdateAmount = {
  amount: AmountType
  deposit: DepositEdit
}

export type DepositStatus = {
  transactionId: string
  status: string
}

export type DepositApproveRequest = {
  status: string
}

export type ExternalTransaction = {
  externalId: string
}

export type ExternalPaymentTransaction = {
  externalId: string
  externalStatus: string
  initialAmount: string
  initialCurrency: string
  paidAmount: string
  paidCurrency: string
  vendorCommission: string
  vendorCommissionCurrency: string
  extraData: string
}

export type ClientPurseResponse = {
  items: ClientPurse[]
  total: number
}

export type Gateway = {
  gatewayId: number
  internalName: string
  processingProvider: string
  paymentMethodType: string
  exchanger: Exchanger
}

export type Exchanger = {
  id: string
  frontName: string
  balance: string
}
export type Error = {
  message: string
  code: number
}

export type DividendBalance = {
  id: number
  balance: string
  currency: string
}

export const dividendBalanceDefault: DividendBalance = {
  id: 0,
  balance: '0',
  currency: 'USD',
}
export type InstalmentItem = {
  sequenceNumber: number
  planStage: number
  transactionRequestId: string
  plannedDate: string
  plannedAmount: string
  paymentDate: string
  paymentAmount: string
  totalAmount: string
  status: string
  installment: Instalment
}
export type Instalment = {
  id: string
}
export const instalmentItemDefault: InstalmentItem = {
  sequenceNumber: 0,
  planStage: 0,
  transactionRequestId: '',
  plannedDate: '',
  plannedAmount: '',
  paymentDate: '',
  paymentAmount: '',
  totalAmount: '',
  status: '',
  installment: {
    id: '',
  },
}
export type InstalmentItemResponse = {
  items: InstalmentItem[]
  total: number
}
export enum TransactionProduct {
  nova = 'nova',
  headway = 'headway',
}

export type AdjustmentDepositPayload = {
  sourceTransactionRequestId: string
  actualClientAmount: number
}
